import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const AboutPage = () => {
  return (
    <div
      style={{ backgroundColor: "#121212", color: "white", minHeight: "100vh" }}
    >
      <Container className="py-5">
        {/* Header Section */}
        <Row className="mb-5">
          <Col>
            <h1 className="text-center text-warning mb-3">
              $SAVEJAMES - About the Community
            </h1>
            <p className="lead text-center">
              A movement dedicated to protecting children and promoting ethical,
              long-term change.
            </p>
          </Col>
        </Row>

        {/* What is $SAVEJAMES? */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-light mb-4">What is $SAVEJAMES?</h2>
            <p className="text-center text-light">
              $SAVEJAMES is the first movement coin on crypto that allows you
              to:
            </p>
            <ul className="text-center text-light">
              <li>Do well while doing good.</li>
              <li>Earn from your good works.</li>
              <li>Take profit and use it for more good.</li>
            </ul>
            <p className="text-center text-light">
              We're your next investment if you care for children and love
              crypto.
            </p>
          </Col>
        </Row>

        {/* Movement Coin Card */}
        <Row className="mb-5">
          <Col md={12}>
            <Card className="bg-dark text-white border-warning">
              <Card.Body>
                <Card.Title className="text-center display-4 text-warning">
                  Movement Coin (noun):
                </Card.Title>
                <Card.Text className="text-center">
                  A cryptocurrency designed to fund and promote positive social
                  movements, leveraging the power of community engagement and
                  decentralized finance to create meaningful change. A
                  meme-inspired digital asset that empowers individuals to
                  support causes they believe in while participating in a
                  global, values-driven economy.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* The Goal of $SAVEJAMES */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-light mb-4">
              The Goal of $SAVEJAMES
            </h2>
            <p className="text-center text-light">
              To stop the medical abuse of children by chemical and physical
              castration in transgender procedures.
            </p>
          </Col>
        </Row>

        {/* What We Believe */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-light mb-4">What We Believe</h2>
            <ul className="text-center text-light">
              <li>Puberty is a human right.</li>
              <li>
                Children cannot consent to medical procedures that sterilize
                them.
              </li>
              <li>Adults cannot sterilize children.</li>
            </ul>
          </Col>
        </Row>

        {/* Our Foundation */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-light mb-4">Our Foundation</h2>
            <ul className="text-center text-light">
              <li>
                Common sense: Chemical castration destroys the future of
                children and removes their right to choose their own identity as
                adults.
              </li>
              <li>
                Goodwill: Most of our members have children. We want to secure
                the world for children so that families can be safe.
              </li>
              <li>
                Science: Chemical castration of children is unsafe and
                ineffective. $SAVEJAMES follows the most extensive scientific
                review of puberty blockers in history, the Cass Review.
              </li>
            </ul>
          </Col>
        </Row>

        {/* What $SAVEJAMES is NOT */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-light mb-4">
              What $SAVEJAMES is NOT
            </h2>
            <ul className="text-center text-light">
              <li>
                Not a joke: This is not just a meme coin. $SAVEJAMES is a
                serious movement for positive social change.
              </li>
              <li>
                Not fly-by-night profit takers: $SAVEJAMES is here for the long
                term until the scourge of chemical castration no longer
                threatens children worldwide.
              </li>
              <li>
                Not going away: $SAVEJAMES is based on a preexisting movement
                that has been here for decades. This is not a passing fad.
              </li>
            </ul>
          </Col>
        </Row>

        {/* Origins of $SAVEJAMES */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-light mb-4">
              Origins of $SAVEJAMES
            </h2>
            <p className="text-center text-light">
              $SAVEJAMES was created on the PumpFun launchpad on the Solana
              Network. On 27th November, it graduated successfully to the
              Raydium liquidity pool.
            </p>
          </Col>
        </Row>

        {/* Join the Movement */}
        <Row className="text-center">
          <Col>
            <Button
              variant="warning"
              size="lg"
              href="https://dexscreener.com/solana/enyvkesxxfeoy8wgpf9hedh7qnfbcxwo9awt3kjk8fyw"
              target="_blank"
            >
              Join the Movement
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutPage;
